/**
 *
 * Asynchronously loads the component for Per002
 * Author: Thuantq1
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
